import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import PremiumHomepage from "./pages/PremiumHomepage";
import TrustPage from "./pages/TrustPage";
import PlatformAppealGuidePage from "./pages/PlatformAppealGuidePage";
import CaseReviewPage from "./pages/CaseReviewPage";
import PlatformDisputePage from "./pages/PlatformDisputePage";
import NoticeOfDisputePage from "./pages/NoticeOfDisputePage";
import RegisteredAgentPage from "./pages/RegisteredAgentPage";
import ContactPage from "./pages/ContactPage";
import DisclaimerPage from "./pages/DisclaimerPage";
import AboutPage from "./pages/AboutPage";
import FAQPage from "./pages/FAQPage";
import ArbitrationNoticePage from "./pages/ArbitrationNoticePage";
import BlogPage from "./pages/BlogPage";
import BlogPostPage from "./pages/BlogPostPage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import TermsOfServicePage from "./pages/TermsOfServicePage";
import RefundPolicyPage from "./pages/RefundPolicyPage";
import ThankYouPage from "./pages/ThankYouPage";
import AdvertisingDisclosurePage from "./pages/AdvertisingDisclosurePage";
import ReferralProgramPage from "./pages/ReferralProgramPage";
import CaseTrackerPage from "./pages/CaseTrackerPage";
import AdminLoginPage from "./pages/AdminLoginPage";
import AdminDashboardPage from "./pages/AdminDashboardPage";
import ServicesPage from "./pages/ServicesPage";
import {
  InstagramRecoveryPage,
  FacebookRecoveryPage,
  TikTokRecoveryPage,
  YouTubeRecoveryPage,
  TwitterRecoveryPage,
  LinkedInRecoveryPage,
  UberEatsRecoveryPage,
  GoogleBusinessAppealPage,
  FacebookBusinessManagerAppealPage,
  InstagramAdAccountAppealPage
} from "./pages/PlatformServicePages";
import PricingPage from "./pages/PricingPage";
import CaseWorkflowPage from "./pages/CaseWorkflowPage";
import SuspensionAnalyzerPage from "./pages/SuspensionAnalyzerPage";
import SuspensionTrendsPage from "./pages/SuspensionTrendsPage";
import AdminTriagePage from "./pages/AdminTriagePage";
import AppealLetterGeneratorPage from "./pages/AppealLetterGeneratorPage";
import ProgrammaticAppealPage from "./pages/ProgrammaticAppealPage";
import EmbedAnalyzerPage from "./pages/EmbedAnalyzerPage";
import EmbedBuilderPage from "./pages/EmbedBuilderPage";
import DataReportsPage from "./pages/DataReportsPage";
import TosTrackerPage from "./pages/TosTrackerPage";
import AdminBacklinksPage from "./pages/AdminBacklinksPage";
import AdminReferralsPage from "./pages/AdminReferralsPage";
import AdminReindexPage from "./pages/AdminReindexPage";
import PressPage from "./pages/PressPage";
import AppealOutcomesReportPage from "./pages/AppealOutcomesReportPage";
import { captureFromUrl } from "./lib/refTracker";
import CookieConsent from "./components/CookieConsent";

function App() {
  // Fire once on first mount: read ?ref=CODE from the URL, persist, and
  // log a click event so admins see the referrer traffic in /admin/referrals.
  useEffect(() => {
    captureFromUrl();
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<PremiumHomepage />} />
          <Route path="/process" element={<CaseWorkflowPage />} />
          <Route path="/analyze" element={<SuspensionAnalyzerPage />} />
          <Route path="/suspension-analyzer" element={<SuspensionAnalyzerPage />} />
          <Route path="/data/suspension-trends" element={<SuspensionTrendsPage />} />
          <Route path="/admin/triage" element={<AdminTriagePage />} />
          {/* Trust & Verification */}
          <Route path="/trust" element={<TrustPage />} />
          {/* Ad Landing Pages - Education First */}
          <Route path="/platform-appeal-guide" element={<PlatformAppealGuidePage />} />
          <Route path="/case-review" element={<CaseReviewPage />} />
          {/* Platform-specific dispute pages */}
          <Route path="/facebook-account-dispute" element={<PlatformDisputePage />} />
          <Route path="/instagram-account-dispute" element={<PlatformDisputePage />} />
          <Route path="/tiktok-account-dispute" element={<PlatformDisputePage />} />
          <Route path="/youtube-account-dispute" element={<PlatformDisputePage />} />
          <Route path="/x-twitter-account-dispute" element={<PlatformDisputePage />} />
          <Route path="/reddit-account-dispute" element={<PlatformDisputePage />} />
          <Route path="/snapchat-account-dispute" element={<PlatformDisputePage />} />
          {/* Info pages */}
          <Route path="/notice-of-dispute" element={<NoticeOfDisputePage />} />
          <Route path="/platform-registered-agent-addresses" element={<RegisteredAgentPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/disclaimer" element={<DisclaimerPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/faq" element={<FAQPage />} />
          <Route path="/arbitration-notice" element={<ArbitrationNoticePage />} />
          {/* Legal pages - full paths */}
          <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
          <Route path="/terms-of-service" element={<TermsOfServicePage />} />
          <Route path="/refund-policy" element={<RefundPolicyPage />} />
          <Route path="/advertising-disclosure" element={<AdvertisingDisclosurePage />} />
          {/* Legal pages - short paths for easy access */}
          <Route path="/privacy" element={<PrivacyPolicyPage />} />
          <Route path="/terms" element={<TermsOfServicePage />} />
          <Route path="/refund" element={<RefundPolicyPage />} />
          <Route path="/referral-program" element={<ReferralProgramPage />} />
          <Route path="/track-case" element={<CaseTrackerPage />} />
          <Route path="/admin" element={<AdminLoginPage />} />
          <Route path="/admin/dashboard" element={<AdminDashboardPage />} />
          <Route path="/pricing" element={<PricingPage />} />
          
          {/* Platform-Specific SEO Landing Pages */}
          <Route path="/services/instagram-account-appeal" element={<InstagramRecoveryPage />} />
          <Route path="/services/facebook-account-appeal" element={<FacebookRecoveryPage />} />
          <Route path="/services/tiktok-account-appeal" element={<TikTokRecoveryPage />} />
          <Route path="/services/youtube-account-appeal" element={<YouTubeRecoveryPage />} />
          <Route path="/services/twitter-account-appeal" element={<TwitterRecoveryPage />} />
          <Route path="/services/x-account-appeal" element={<TwitterRecoveryPage />} />
          <Route path="/services/linkedin-account-appeal" element={<LinkedInRecoveryPage />} />
          <Route path="/services/ubereats-account-appeal" element={<UberEatsRecoveryPage />} />
          <Route path="/services/google-business-profile-suspended" element={<GoogleBusinessAppealPage />} />
          <Route path="/services/facebook-business-manager-disabled" element={<FacebookBusinessManagerAppealPage />} />
          <Route path="/services/instagram-ad-account-disabled" element={<InstagramAdAccountAppealPage />} />
          <Route path="/letter" element={<AppealLetterGeneratorPage />} />
          <Route path="/appeal-letter-generator" element={<AppealLetterGeneratorPage />} />

          {/* Programmatic long-tail SEO: /appeal/:platform/:reason */}
          <Route path="/appeal/:platform/:reason" element={<ProgrammaticAppealPage />} />

          {/* Backlink growth engine — public tools */}
          <Route path="/embed/analyzer" element={<EmbedAnalyzerPage />} />
          <Route path="/tools/embed" element={<EmbedBuilderPage />} />
          <Route path="/data/reports" element={<DataReportsPage />} />
          <Route path="/tools/tos-tracker" element={<TosTrackerPage />} />

          {/* Admin — Backlink Command Center */}
          <Route path="/admin/backlinks" element={<AdminBacklinksPage />} />
          <Route path="/admin/referrals" element={<AdminReferralsPage />} />
          <Route path="/admin/reindex" element={<AdminReindexPage />} />

          {/* Press kit */}
          <Route path="/press" element={<PressPage />} />
          {/* Research reports — Asset #1 from the Oct 8 backlink playbook */}
          <Route path="/research/appeal-outcomes-2026" element={<AppealOutcomesReportPage />} />
          
          <Route path="/thank-you" element={<ThankYouPage />} />
          {/* Blog */}
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/blog/:slug" element={<BlogPostPage />} />
        </Routes>
      </BrowserRouter>
      <CookieConsent />
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
